// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"4067921c","182":"878c4b18","207":"5ebe7394","242":"f753b466","444":"accbbd6b","534":"697bdb6f","553":"8f1bcfa8","686":"1fd01f00","742":"b6d7293d","798":"ed0db169","867":"588a2b07","936":"f69e9620"}[chunkId] + ".chunk.js";
};